import React, { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../layouts';
import Welcome from '../../../layouts/welcome';
import Row from '../../../components/row';
import Container from '../../../layouts/containers/container';
import List from '../../../components/list';
import Divider from '../../../components/divider/divider';
import ContainerGrid from '../../../layouts/containers/container-grid';
import Grid from '../../../components/grid';
import InputsCounter from '../../../components/inputs/inputs-counter';
import DateTimeInput from '../../../components/inputs/date-time-input';
import LabelContainer from '../../../components/label-container';
import meetingsApi from '../../../lib/meetings/meetings-api';
import Blurred from '../../../components/blurred';

import MediaHelper from '../../../lib/helpers/media';
import eventsApi from '../../../lib/events/events-api';
import { getDSTLocalTime } from '../../../lib/helpers/datetime-helpers';
import queryString from 'query-string';
import humanizeDuration from 'humanize-duration';

import RenderThisIf from '../../../components/renderIf';
import Darkener from '../../../components/darkener';

import NavItem from '../nav-link';

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import seamApi from '../../../lib/seam-api';

class Event extends Component {
    constructor(props) {
        super(props);

        this.state = {
            event: null,
            lightbox: null,
            params: {
                tickets: []
            },
            topBarRef: null,
            imageRef: null,
            oldImageRef: null,
        }
    }

    componentDidMount() {
        this.getEvent();
        this.onResize()
    }

    onImageRef(ref) {
        if (this.state.imageRef === null) {
            this.setState({ imageRef: ref }, () => {
                this.resizeImage();
            })
        }
    }

    onTopBarRef(ref) {
        if (this.state.topBarRef === null) {
            this.setState({ topBarRef: ref }, () => {
                this.resizeImage();
            })
        }
    }

    onResize() {    
        this.resizeImage();

        window.addEventListener('resize', this.resizeImage.bind(this))
    }

    resizeImage() {
        const overflow = 100;

        if (this.state.imageRef !== null) {
            this.state.imageRef.style.height = `calc(300.96px + ${this.state.topBarRef?.offsetHeight}px + ${overflow}px)`;
        }
    }

    getEvent() {
        seamApi.events().getBySlug(this.props.id, {}).then(({ data }) => {
            this.setState({ event: data }, () => {
                this.setupTickets();
            })
        });
    }

    handleProceed() {
        let id = this.state.event.id;
        let form = document.createElement('form');

        form.action = '/events/' + id;
        form.method = 'post';

        const mappedTickets = this.state.params?.tickets?.map(ticket => {
            return {
                id: ticket.id,
                quantity: ticket.quantity,
            }
        }).filter(({ quantity }) => quantity > 0).reduce((result, item) => {
            result[item.id] = item.quantity;
            return result;
        }, {});

        if (Object.keys(mappedTickets)?.length > 0) {
            let input = document.createElement('input');
                input.name = 'tickets';
                input.type = 'hidden';
                input.value = queryString.stringify(mappedTickets)
                form.appendChild(input);
        }

        document.body.appendChild(form);

        form.submit();
    }

    // proceed() {
    //     const url = new URL(`${window.location.origin}/mydmc/events/${this.state.event.id}/book`);
        
    //     const mappedTickets = this.state.params?.tickets?.map(ticket => {
    //         return {
    //             id: ticket.id,
    //             quantity: ticket.quantity,
    //         }
    //     }).filter(({ quantity }) => quantity > 0).reduce((result, item) => {
    //         result[item.id] = item.quantity;
    //         return result;
    //     }, {});

    //     if (Object.keys(mappedTickets)?.length > 0) {
    //         url.searchParams.set('tickets', queryString.stringify(mappedTickets))
    //     }

    //     window.location.href = url.href;
    // }

    onChangeObject(obj, callback = () => {}) {
        const params = { 
            ...this.state.params,
            ...obj 
        }

        this.setState({ params }, callback)
    }

    setupTickets() {
        let tickets = [ ...this.state.event.event_ticket_types ];

        tickets = tickets?.map((ticket) => {
            return {
                ...ticket,
                event_ticket_type_id: ticket?.id,
                quantity: 0,
            }
        });

        this.onChangeObject({ tickets });
    }

    onTicketQuantityChange(id, value) {
        const tickets =  [ ...this.state.params?.tickets ];
        const index = tickets.findIndex(e => e.event_ticket_type_id === id);

        tickets[index].quantity = value;

        this.onChangeObject({ tickets }, () => this.getBookingCosts());
    }

    getBookingCosts = _.debounce(() => {
        seamApi.events().getBookingCosts(this.state.event.id, {
            tickets: this.state.params.tickets?.map(({ event_ticket_type_id, quantity }) => {
                return {
                    event_ticket_type_id,
                    quantity
                }
            }),
            discount: this.state.params?.discount,
        }).then(({ data }) => {
            this.setState({ quote: data }, () => {
                this.addCostsToTickets();
            })
        })
    }, 500, null);
    
    getQuoteTicket(id) {
        const ticket = this.state.quote?.tickets?.find(t => t.event_ticket_type_id === id);

        return {
            total: ticket?.total,
            errors: ticket?.errors,
        }
    }

    addCostsToTickets() {
        let tickets = [ ...this.state.params.tickets ];

        tickets = tickets.map((ticket) => {
            return {
                ...ticket,
                price: this.getQuoteTicket(ticket?.id)?.total
            }
        })

        this.onChangeObject({ tickets });
    }

    getFeaturedImage() {
        const image = this.state.event?.content?.feature_image?.[0];

        if (image?.file_name === undefined) return '/images/office.png';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    render() {
        const slides = this.state.event?.content?.gallery?.map((item, index) => {
            const url = MediaHelper.formatPublicPath(`/images/${item?.file_name}`);

            return { src: url }
        }) || []

        const featureImage = this.getFeaturedImage();

        if (this.state.event === null) return null;

        return (
        <div className="meeting-booking event">
            <Darkener ref={this.onImageRef.bind(this)} className="meeting-booking__image-outer">
                <div className="meeting-booking__image-outer" style={{ 
                    backgroundImage: `url('${featureImage}')`
                }}></div>
            </Darkener>
                
            <Layout
                onlyContent
                theme="light"
                topLeft={<Welcome breadcrumbs={[
                    {
                        name: 'Events',
                        link: ''
                    },
                    {
                        name: this.state.event?.name,
                        link: ''
                    }
                ]} subtitle={this.state.event?.name}/>}
                topRight={
                    <Row gap="20px">
                        <button className="meeting-booking__proceed">
                            <NavItem slug="#" onClick={() => this.handleProceed()} text="Proceed To Booking" />
                        </button>
                    </Row>
                }
                topBarRef={this.onTopBarRef.bind(this)}
            >
                <Lightbox
                    open={this.state.lightbox !== null}
                    close={() => this.setState({ lightbox: null })}
                    slides={slides}
                    index={this.state.lightbox}
                />

                    <div className="meeting-booking__content">
                        <List gap="20px" className="meeting-booking__inner" divider={<Divider/>}>
                                <SixtyFourtyLayout
                                    main={
                                        <List gap="50px">
                                            <div class="bac-bar">
                                                <p style={{ fontSize: '14px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path id="Path_689" data-name="Path 689" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM11,11v6h2V11Zm0-4V9h2V7Z" transform="translate(-2 -2)" fill="#fcfcfc"/>
                                                    </svg>

                                                    <b>Payment via BACS only</b> Setup will be processed via your myDMC account.
                                                </p>
                                            </div>

                                            <Grid columns={2} gap="40px">
                                                <RenderThisIf 
                                                    renderIf={this.state.event?.external === false}
                                                    render={
                                                        <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Tickets Prices</Container.Text>}>
                                                            <List gap="20px">
                                                                { this.state.params.tickets?.map((ticket, index) => {
                                                                    return <div key={index}>{ ticket?.name } - £{ ticket?.ticket_price }</div>
                                                                }) }
                                                            </List>
                                                        </LabelContainer>
                                                    }
                                                />

                                                <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Event Location</Container.Text>}>
                                                    <Container.Text html={ this.state.event?.content?.location }></Container.Text>
                                                </LabelContainer>

                                                <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Event Date & Time</Container.Text>}>
                                                    { getDSTLocalTime(this.state.event?.start).format('HH:mm A') } - { getDSTLocalTime(this.state.event?.start).add(this.state.event?.duration_mins, 'minutes').format('HH:mm A - DD/MM/YYYY') }
                                                </LabelContainer>

                                                <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Duration</Container.Text>}>
                                                    { humanizeDuration(this.state.event?.duration_mins * 1000 * 60) }
                                                </LabelContainer>

                                                <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Host</Container.Text>}>
                                                    { this.state.event?.host_override }
                                                </LabelContainer>
                                            </Grid>

                                            <Container>
                                                <Container.Header>
                                                    <Container.Text fontSize="18px" color="#FF6933">Event Overview</Container.Text>
                                                </Container.Header>

                                                <Container.Content>
                                                    <Container.Text fontSize="16px" color="#24191F" html={this.state.event?.description}></Container.Text>
                                                </Container.Content>
                                            </Container>
                                        </List>
                                    }
                                    sectionOne={
                                        {
                                            name: 'Availability',
                                            component: <List gap="40px">
                                                <List>
                                                    <Container className="meetings-listing__availability">
                                                        <RenderThisIf 
                                                            renderIf={this.state.event?.external === true}
                                                            render={
                                                                <>
                                                                    <Container.Header>
                                                                        <List gap="10px">
                                                                            <Container.Text fontSize="20px" color="white">Event tickets on: { this.state?.event?.external_link }</Container.Text>
                                                                        </List>
                                                                    </Container.Header>
                                                                    <Container.Content className="meetings-listing-availability__content">
                                                                        <Button className="button--view" onClick={() => this.handleProceed()}>Proceed To Booking</Button>   
                                                                    </Container.Content>
                                                                </>
                                                            }
                                                        >
                                                            <Container.Header>
                                                                <List gap="10px">
                                                                    <Container.Text fontSize="20px" color="white">Ticket Availability</Container.Text>
                                                                    <Container.Text fontSize="16px" color="#1976F8">Maximum { this.state.event?.max_tickets_per_booking } tickets per booking</Container.Text>
                                                                </List>
                                                            </Container.Header>
                                                            <Container.Content className="meetings-listing-availability__content">
                                                                <List gap="20px">
                                                                    <List gap="20px" divider={<Divider top="10px" bottom="10px" color="#15AAA6"/>}>
                                                                        { this.state.params.tickets?.map((ticket, index) => {
                                                                            return (
                                                                                <Row key={index} gap="20px" justifyContent="space-between" className="meeting-booking__ticket">
                                                                                    <LabelContainer label={<Container.Text fontSize="16px" color="white" className="ticket__name">{ ticket?.name }</Container.Text>}>
                                                                                        <Container.Text fontSize="14px" color="white">£{ticket?.price || 0}</Container.Text>
                                                                                    </LabelContainer>

                                                                                    <Blurred toggled={ticket?.no_tickets_remaining === 0}>
                                                                                        <InputsCounter
                                                                                            value={ticket?.quantity}
                                                                                            onChange={e => this.onTicketQuantityChange(ticket?.id, e)}
                                                                                            max={ticket?.quantity_available}
                                                                                            color="white"
                                                                                        />
                                                                                    </Blurred>
                                                                                </Row>
                                                                            )
                                                                        })}      
                                                                    </List>

                                                                    <Divider top="10px" bottom="10px" color="#15AAA6"/>

                                                                    <Row gap="20px" justifyContent="space-between">
                                                                        <LabelContainer label={<Container.Text fontSize="14px" color="#1976F8">Cost of booking</Container.Text>}>
                                                                            <Container.Text fontSize="20px" color="white">£{ this.state.quote?.total || 0.00 }</Container.Text>
                                                                        </LabelContainer>
                                                                    </Row>                                
                                                                </List>
                                                            </Container.Content>
                                                        </RenderThisIf>
                                                    </Container>
                                                    <button className="meeting-booking__proceed meeting-booking__proceed--blue">
                                                        <NavItem onClick={() => this.handleProceed()} text="Proceed To Booking"/>
                                                    </button>
                                                </List>

                                                <RenderThisIf 
                                                    renderIf={this.state.event?.content?.contact_details?.length > 0}
                                                    render={
                                                        <LabelContainer label={<Container.Text fontSize="18px" color="#FF6933">Contact Details</Container.Text>}>
                                                            <Container.Text html={this.state.event?.content?.contact_details}></Container.Text>
                                                        </LabelContainer>
                                                    }
                                                />
                                            </List>

                                        }
                                    }
                                />

                                <div className="meetings-listing__image" role="img" aria-label="Meeting Room Cover Image" style={{ backgroundImage: `url('${featureImage}')`}}></div>
                                
                                <Container>
                                    <Container.Header>
                                        <Container.Text fontSize="18px" color="#929BA8">Gallery Block</Container.Text>
                                    </Container.Header>

                                    <Container.Content>
                                        <ContainerGrid>
                                            { this.state.event?.content?.gallery?.map((item, index) => {
                                                const url = MediaHelper.formatPublicPath(`/images/${item?.file_name}`);

                                                return <div key={index} onClick={() => this.setState({ lightbox: index })} className="meetings-listing-gallery__item" style={{ backgroundImage: `url('${url}')` }}></div> 
                                            }) }
                                        </ContainerGrid>
                                    </Container.Content>
                                </Container>

                                <Container>
                                    <Container.Header>
                                        <Container.Text fontSize="18px" color="#929BA8">Additional Information</Container.Text>
                                    </Container.Header>

                                    <Container.Content>
                                        <Grid columns={2} gap="20px">
                                            <RenderThisIf
                                                renderIf={this.state?.event?.content?.additional_information_one?.label?.length > 0}
                                                render={
                                                    <Container>
                                                    <Container.Header>
                                                        <Container.Text fontSize="14px" color="#CECECE">{ this.state?.event?.content?.additional_information_one?.label }</Container.Text>
                                                    </Container.Header>

                                                    <Container.Content>
                                                        <Container.Text fontSize="18px" color="#354859" html={this.state?.event?.content?.additional_information_one?.description}></Container.Text>
                                                    </Container.Content>
                                                </Container>
                                                }
                                            />

                                            <RenderThisIf
                                                renderIf={this.state?.event?.content?.additional_information_two?.label?.length > 0}
                                                render={
                                                    <Container>
                                                    <Container.Header>
                                                        <Container.Text fontSize="14px" color="#CECECE">{ this.state?.event?.content?.additional_information_two?.label }</Container.Text>
                                                    </Container.Header>

                                                    <Container.Content>
                                                        <Container.Text fontSize="18px" color="#354859" html={this.state?.event?.content?.additional_information_two?.description}></Container.Text>
                                                    </Container.Content>
                                                </Container>
                                                }
                                            />
                                        </Grid>
                                    </Container.Content>
                                </Container>
                            </List>
                    </div>
                </Layout>   
            </div>
        )
    }
}

const el = document.getElementById('event');

if (el) {
    ReactDOM.render(<Event id={el.getAttribute('data-id')}/>, el);
}
